<div class="sort-content">
  <p (click)="onSortChanged(option)" *ngFor="let option of sortOptions;">{{option.label}}</p>
</div>
